import { useEffect } from 'react';
import type { RemarketingData } from 'autogen/swagger/all';

let hasRunOnce = false;

export default function usePushRemarketingDataOnce(remarketingData: RemarketingData) {
    useEffect(() => {
        if (!hasRunOnce) {
            hasRunOnce = true;
            window.dataLayer?.push(remarketingData);
        }
    }, [remarketingData]);

    return null;
}
